var _g, _g2, _g3, _g4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function Svg4(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "https:_www.flaticon.com_free-icon_stationary-bike_883386_term_fitness_20gym_page_3_position_1",
    "data-name": "https://www.flaticon.com/free-icon/stationary-bike_883386#term=fitness%20gym&page=3&position=1",
    xmlns: "http://www.w3.org/2000/svg",
    width: 90.16,
    height: 90.16,
    viewBox: "0 0 90.16 90.16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_2",
    "data-name": "Group 2",
    transform: "translate(46.841 69.029)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1",
    "data-name": "Group 1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_60",
    "data-name": "Path 60",
    d: "M267.761,392a1.761,1.761,0,1,0,1.761,1.761A1.762,1.762,0,0,0,267.761,392Z",
    transform: "translate(-266 -392)",
    fill: "#ff1414"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Group_4",
    "data-name": "Group 4"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3",
    "data-name": "Group 3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_61",
    "data-name": "Path 61",
    d: "M84.877,79.594H84.8A13.808,13.808,0,0,0,90.16,69.029a14.119,14.119,0,0,0-9.368-13.278l-.023-.008L65.717,50.618l5.536-28.43h2a8.815,8.815,0,0,0,8.8-8.8v-8.1a5.283,5.283,0,1,0-10.566,0v6.339h-8.8a5.28,5.28,0,0,0-2.118,10.117L55.628,47.183,30.55,38.645A22.682,22.682,0,0,0,26,37.544L22.915,25.71h5.776a6.528,6.528,0,0,0,1.073-12.966C8.3,9.205,9.423,9.264,8.208,9.264A8.223,8.223,0,0,0,8.222,25.71h3.741l3.369,12.9a22.9,22.9,0,0,0-4.645,40.982h-5.4a5.283,5.283,0,0,0,0,10.566H84.877a5.283,5.283,0,0,0,0-10.566ZM62.689,15.144H73.255a1.761,1.761,0,0,0,1.761-1.761v-8.1a1.761,1.761,0,1,1,3.522,0v8.1a5.289,5.289,0,0,1-5.283,5.283H62.763c-.056,0-.112-.006-.168-.005a1.759,1.759,0,0,1,.095-3.516Zm1.383,7.044h3.593L62.352,49.473l-3.36-1.144Zm-55.85,0a4.7,4.7,0,0,1-.014-9.4c.72,0-.16-.069,20.977,3.431a3.006,3.006,0,0,1-.494,5.971ZM22.3,37.341a22.968,22.968,0,0,0-3.567.371l-3.134-12h3.672ZM3.522,60.224A19.374,19.374,0,0,1,29.38,41.967l.023.008,50.22,17.1a10.591,10.591,0,0,1,7.015,9.956c0,5.528-5.537,10.387-11.617,10.39l-54.638.016A19.385,19.385,0,0,1,3.522,60.224ZM84.877,86.638H5.283a1.761,1.761,0,0,1,0-3.522H84.877a1.761,1.761,0,0,1,0,3.522Z",
    fill: "#ff1414"
  })))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Group_6",
    "data-name": "Group 6",
    transform: "translate(57.407 58.463)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5",
    "data-name": "Group 5"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_62",
    "data-name": "Path 62",
    d: "M334.8,332a8.8,8.8,0,1,0,8.8,8.8A8.815,8.815,0,0,0,334.8,332Zm0,14.088a5.283,5.283,0,1,1,5.283-5.283A5.289,5.289,0,0,1,334.8,346.088Z",
    transform: "translate(-326 -332)",
    fill: "#ff1414"
  })))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "Group_8",
    "data-name": "Group 8",
    transform: "translate(10.566 47.898)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7",
    "data-name": "Group 7"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_63",
    "data-name": "Path 63",
    d: "M90.993,293.131H83.622L82.2,291.709a12.324,12.324,0,1,0-2.49,2.49l1.938,1.938a1.761,1.761,0,0,0,1.245.516h8.1a1.761,1.761,0,0,0,0-3.522Zm-11.319-3.948-6.1-6.1a1.761,1.761,0,0,0-2.49,2.49l6.1,6.1a8.8,8.8,0,1,1,2.49-2.49Z",
    transform: "translate(-60 -272)",
    fill: "#ff1414"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg4);
export default __webpack_public_path__ + "static/media/4.7eb09c3d9444763ee3d16b2625a4cf29.svg";
export { ForwardRef as ReactComponent };